export const Badge = ({ desc }) => {

    if (desc) {
      return <span class='notify-badge'>{desc}</span>;
    }
    return <span class='notify'></span>;
  }